import React from 'react';
import { PageBanner } from '../components/PageBanner';
import { ServicesSection } from '../components/ServicesSection';
import { ContactCTA } from '../components/ContactCTA';
export function ServicesPage() {
  return <main className="bg-light min-h-screen" data-id="element-1289">
      <PageBanner title="Our Services" subtitle="Comprehensive home healthcare solutions tailored to your unique needs." breadcrumbs={[{
      label: 'Services',
      path: '/services'
    }]} data-id="element-1290" />
      <ServicesSection showViewAllButton={false} data-id="element-1291" />
      <ContactCTA className="bg-light-alt" data-id="element-1292" />
    </main>;
}